<template>
  <li>
    <div>
      <a
        href=""
        @click.prevent="openCategory"
        :class="{ 'main-cat': isMainCategory }"
        class="tw-text-mainbg1 hover:tw-text-mainbg1 tw-no-underline [&:has(+)]:bg-red-500"
      >
        {{ category.spellingRuleName }}
      </a>
    </div>
    <Transition name="scale">
      <ul v-if="hasSubCategories && expanded" class="tw-overflow-hidden">
        <HomeSpellingRuleCategoryTree
          v-for="c of category.subCategories"
          :category="c"
          :level="level + 1"
          :key="c.id"
          :expanded-id="innerExpandedId"
          @expand="toggleExpanded(c.id)"
          class="subcat tw-text-lg tw-text-left tw-font-normal tw-pl-8"
        />
        <li v-if="level == 0" class="tw-pb-8"></li>
      </ul>
    </Transition>
  </li>
</template>

<style scoped lang="postcss">
.subcat :deep(a) {
  @apply hover:tw-underline;
}

.main-cat {
  @apply tw-inline-block tw-w-full tw-p-4;
}

.scale-enter-active,
.scale-leave-active {
  transition: all 0.5s ease;
  max-height: 500px;
}
.scale-enter-from,
.scale-leave-to {
  max-height: 0px;
}
</style>

<script lang="ts">
import { SfWordCategory } from "@/types/spellingTypes";
import { PropType } from "vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeSpellingRuleCategoryTree",
  components: {},
  props: {
    category: { type: Object as PropType<SfWordCategory>, required: true },
    level: { type: Number, default: 0 },
    expandedId: { type: Number, required: true },
  },
  emits: ["expand"],
  data() {
    return {
      innerExpandedId: 0,
    };
  },
  computed: {
    isMainCategory() {
      return this.category.parent_category_id == null;
    },
    hasSubCategories(): boolean {
      if (!this.category.subCategories) {
        return false;
      }
      const catCount = this.category.subCategories.reduce<number>((val, c) => {
        return val + (c.word_count > 0 ? 0 : 1);
      }, 0);
      return catCount > 0;
    },
    routerUrl(): string {
      return (
        "/spelling/category/" +
        this.category.id +
        "/" +
        this.category.spellingRuleName
      );
    },
    expanded(): boolean {
      return this.expandedId == this.category.id;
    },
  },
  methods: {
    openCategory() {
      if (this.hasSubCategories) {
        this.$emit("expand", this.category.id);
        return;
      }
      this.$router.push(this.category.url);
    },
    toggleExpanded(catId: number) {
      this.innerExpandedId = this.innerExpandedId == catId ? 0 : catId;
    },
  },
});
</script>
